import Environment from 'StorytellerEnvironment';
import type { StorytellerState } from 'store/StorytellerReduxState';
import {
  storyReducerBlocksSelector,
  storyReducerStoriesSelector,
  storySaveStatusSelector,
} from 'store/TopLevelSelector';
import { getDataSourceForSerialize } from './DataSourceSelectors';
import { getStory, isStoryDirty } from './StorySelectors/Stories';
import { serializeStoryFromState } from './StorySelectors/StorySerialize';

/* Selectors */
export const getUserCausingConflict = (state: StorytellerState) =>
  storySaveStatusSelector(state).userCausingConflict;
export const isSaveImpossibleDueToConflict = (state: StorytellerState) =>
  storySaveStatusSelector(state).poisonedWithSaveConflictForever;
export const isStorySaveInProgress = (state: StorytellerState) =>
  storySaveStatusSelector(state).saveInProgress;
export const getLastSaveError = (state: StorytellerState) => storySaveStatusSelector(state).lastSaveError;
export const getErrorMessage = (state: StorytellerState) => storySaveStatusSelector(state).errorMessage;
export const getHasBeenPublished = (state: StorytellerState) =>
  storySaveStatusSelector(state).hasBeenPublished;
export const getLastSerializedStory = (state: StorytellerState) =>
  storySaveStatusSelector(state).lastSerializedStory;

export const isStorySavePossible = (state: StorytellerState) => {
  return !(isStorySaveInProgress(state) || isStorySaved(state) || isSaveImpossibleDueToConflict(state));
};

export const isStorySaved = (state: StorytellerState) => {
  const storyUid = Environment.STORY_UID as string;
  const stories = storyReducerStoriesSelector(state);

  const story = getStory(storyUid, stories);
  const dataSources = getDataSourceForSerialize(state);
  const blocks = storyReducerBlocksSelector(state);

  const currentSerializedStory = serializeStoryFromState(story, blocks, dataSources);
  const lastSerializedStory = storySaveStatusSelector(state).lastSerializedStory;
  const lastSaveError = storySaveStatusSelector(state).lastSaveError;
  const isStorySaving = !!isStorySaveInProgress(state);
  return lastSerializedStory
    ? !isStoryDirty(currentSerializedStory, lastSerializedStory, isStorySaving, lastSaveError)
    : false;
};
